<div class="wrapper">
  <app-header></app-header>
  <div class="main">
      <div class="container-fluid container-fluid-5">
          <div class="row row5">
              <div class="sidebar col-md-2 hide-small">
                  <app-sidebar></app-sidebar>
              </div>
              <div class="col-12 hide-large featured-box">
              </div>
              <div class="col-md-10 report-main-content m-t-5">
                <div class="card">
                  <div class="card-header"><h4 class="mb-0">Profit Loss</h4></div>
                  <div class="card-body container-fluid container-fluid-5">
                    <div class="row row5">
                      <div class="col-sm-2 col-md-2 col-6">
                        <div class="mx-input-wrapper">
                          <input type="text" class="mx-input" [popover]="popTemplateStatementStart"
                          placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                          value="{{statementStartDate | date:'yyyy-MM-dd'}}" (click)="showDate()">
                          <span class="mx-input-append"><i class="fa fa-calendar-o"></i></span>
                        </div>
                      </div>
                      <div class="col-sm-2 col-md-2 col-6">
                        <div class="mx-input-wrapper">
                          <input type="text" class="mx-input" [popover]="popTemplateStatementEnd"
                          placement="bottom" [outsideClick]="true" #popoverRef="bs-popover"
                          value="{{statementEndDate | date:'yyyy-MM-dd'}}" (click)="showDate()">
                          <span class="mx-input-append"><i class="fa fa-calendar-o"></i></span>
                        </div>
                      </div>
                      <div class="col-sm-1 col-md-1 col-12 btn-col">
                        <button class="btn btn-primary btn-block mobile-width" (click)="eventpl('filterBtnClick')">Submit</button>
                      </div>
                    </div>

                    <div class="row row5 mt-2">
                      <div class="col-12">
                        <div class="table-responsive">
                          <table class="table b-table dataTable table-striped table-bordered" >
                            <thead>
                              <tr>
                                <th>Sport Name</th>
                                <th>Profit / Loss</th>
                                <th>Commission</th>
                                <th>Total P&L</th>      
                              </tr>
                            </thead>
                            <tbody *ngIf="sportPlListLength != 0">
                                <tr *ngFor="let data of sportPlList;let i = index;">
                                    <td style="cursor: pointer;color:blue;" (click)="eventWisePl(data)" >{{data?.sport_name}}</td>
                                    <td  [ngClass]="{'green':data.total >= 0 ,'red':data.total < 0  }"> {{(data.total | number :'0.0-2') }}</td>
                                    <td [ngClass]="{'red':data.commission < 0}">{{data.commission < '0' ? (data.commission | number :'0.0-2') : '0'}}</td>
                                    <td  [ngClass]="{'red':data.totalPL < 0 ,'green':data.totalPL >= 0}">{{data.totalPL| number :'0.0-2'}}</td>
                                </tr>
                            </tbody>
                          </table>
                          <div *ngIf="sportPlListLength == 0">
                            <p class="mb-0 text-center">There are no records to show</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
      </div>
  </div>
</div>

<app-footer-main></app-footer-main>


<!-- Date Time Picker -->
<ng-template #popTemplateStatementStart>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="dateStatement" [minDate]="minDate"  [maxDate] ="todayDateTime"[showWeeks]="false"
        (ngModelChange)="updateDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="timeStatement" [min]="minTime" [max]="maxTime" (ngModelChange)="updateTimeStatement()" [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="close()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>
<ng-template #popTemplateStatementEnd>
    <datepicker [hidden]="!isDateVisible" [(ngModel)]="endDateStatement" [minDate]="dateStatement" [maxDate] ="todayDateTime" [showWeeks]="false"
        (ngModelChange)="updateEndDateStatement()" (selectionDone)="dateSelectionDone()">
    </datepicker>
    <timepicker [hidden]="!isDateVisible" [(ngModel)]="endTimeStatement" [min]="minTime" [max]="maxTime"  (ngModelChange)="updateEndTimeStatement()"
        [showMeridian]="isMeridian" showSeconds="true">
    </timepicker>

    <div style="padding:5px">
        <span class="btn-group pull-left" style="margin-right:10px;">
            <button type=button class="btn btn-sm btn-info" [hidden]="!isDateVisible" (click)="today()">Today</button>
            <button type=button class="btn btn-sm btn-danger" (click)="clear()">Clear</button>
        </span>
        <span class="btn-group pull-right">
            <!-- <button type=button class="btn btn-sm btn-light" [hidden]="isDateVisible" 
            (click)="showDate()">Date
            </button>
            <button type=button class="btn btn-sm btn-light" [hidden]="!isDateVisible" 
            (click)="showTime()">Time
            </button> -->
            <button type=button class="btn btn-sm btn-success" (click)="closeEndDatepicker()">Close</button>
        </span> <span class=clearfix></span>
    </div>
</ng-template>